"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var intl_messageformat_1 = __importDefault(require("intl-messageformat"));
var lodash_1 = require("lodash");
var Internationalization = /** @class */ (function () {
    function Internationalization(_a) {
        var _b = _a.pseudoLocalizationEnabled, pseudoLocalizationEnabled = _b === void 0 ? false : _b, props = __rest(_a, ["pseudoLocalizationEnabled"]);
        this.props = __assign({ pseudoLocalizationEnabled: pseudoLocalizationEnabled }, props);
    }
    Internationalization.prototype.pseudoLocalize = function (s) {
        return this.props.pseudoLocalizationEnabled ? "\u00C0--" + s + "--\u014C" : s;
    };
    /** update initialization props */
    Internationalization.prototype.update = function (_a) {
        var _b = _a.pseudoLocalizationEnabled, pseudoLocalizationEnabled = _b === void 0 ? false : _b, props = __rest(_a, ["pseudoLocalizationEnabled"]);
        this.props = __assign({ pseudoLocalizationEnabled: pseudoLocalizationEnabled }, props);
    };
    /**
     * get property from translation json object without locale formatting.
     * property can be any value (object, array, etc.)
     */
    Internationalization.prototype.getProp = function (path) {
        var missingKey = "--MISSING_LOCALIZATION_KEY--";
        var prop = lodash_1.get(this.props.localeJson, path, missingKey);
        if (prop === missingKey)
            throw new Error("Localization: json prop value is missing, from json path: " + path);
        return prop;
    };
    /** format message to defaultLocale */
    Internationalization.prototype.format = function (message, args) {
        if (args === void 0) { args = {}; }
        var IMF = new intl_messageformat_1.default(this.pseudoLocalize(message), this.props.defaultLocale);
        return IMF.format(args);
    };
    /**
     * get property from translation json object and return locale formatted string.
     * property must have value of string
     */
    Internationalization.prototype.get = function (path, args) {
        if (args === void 0) { args = {}; }
        var prop = this.getProp(path);
        var msg = '';
        if (typeof prop === 'string') {
            msg = this.format(prop, args);
        }
        else
            throw new Error("Localization: json prop value must be a string, from json path: " + path);
        return msg;
    };
    return Internationalization;
}());
exports.Internationalization = Internationalization;
